import { cloneElement, isValidElement, ReactNode } from "react";
export function replaceSmartQuotesAndApostrophes(text: string): string {
  // Apostrophes in words like don't
  text = text.replace(/'/g, "’");

  // Double quotes: alternate between “ and ”
  let doubleIsOpen = true;
  text = text.replace(/"/g, () => {
    const quote = doubleIsOpen ? "“" : "”";
    doubleIsOpen = !doubleIsOpen;
    return quote;
  });

  // Single quotes can interfere with apostrophes
  return text;
}

export function processNodeToSmartQuotes(node: ReactNode): ReactNode {
  if (typeof node === "string") {
    return replaceSmartQuotesAndApostrophes(node);
  }

  if (Array.isArray(node)) {
    return node.map(processNodeToSmartQuotes);
  }

  if (isValidElement(node)) {
    return cloneElement(
      node,
      node.props,
      processNodeToSmartQuotes(node.props.children)
    );
  }

  return node;
}
